export default function SharingFilesBox({ children }) {
    return <div className="">
        <div className="flex items-center justify-between">
            <p>Danh sách các file</p>
        </div>
        { children }
    </div>
}